import { ReactNode } from 'react';

import { Icon } from '@/new/components/icon';
import { Button, ButtonProps } from '@/new/components/shadcn/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/new/components/shadcn/dialog';

interface ConfirmationModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  children: ReactNode;
  onConfirm: () => void;
  isLoading: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: ButtonProps['variant'];
  cancelVariant?: ButtonProps['variant'];
}

export const ConfirmationModal = ({
  isOpen,
  onOpenChange,
  title,
  children,
  onConfirm,
  isLoading,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'primary',
  cancelVariant = 'default',
  ...props
}: ConfirmationModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange} {...props}>
      <DialogContent onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="mb-6">
          {isLoading ? (
            <div className="flex justify-center p-2 text-gray-500">
              <Icon className="lucide--loader animate-spin ease-in-out" />
            </div>
          ) : (
            children
          )}
        </div>

        <div className="flex justify-end gap-2">
          <Button variant={cancelVariant} onClick={() => onOpenChange(false)} disabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button data-testid="confirm-button" variant={confirmVariant} onClick={onConfirm} disabled={isLoading}>
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
